import type { SlideProps } from "@/engine/app/offsite-config";

const TILES = [
  {
    title: "Make.com als Drehscheibe",
    text: "Unsere Automatisierungs-Plattform verbindet Zendesk, kVASy, die SVO-Home-App und Web-Formulare — ohne dass jemand Daten abtippt.",
  },
  {
    title: "Zendesk-Automatisierungen",
    text: "IBAN-Änderung, Zählerstandsmitteilung & Co. — diese Vorgänge laufen automatisch durch, statt von Hand bearbeitet zu werden.",
  },
  {
    title: "kVASy-Webservices & App-Anbindung",
    text: "Verträge, Verbräuche, Dokumente, Umzug: „SVO Home“ spricht über unsere Webservices direkt mit kVASy — Änderungen landen sofort im System.",
  },
  {
    title: "KI-Ansagen in der Telefonanlage",
    text: "Die Ansagen unserer Wählanlage sind KI-generiert — Text rein, fertige Stimme raus. Kein Tonstudio, Änderungen in Minuten.",
  },
];

export function Slide02Automatisierung(_: SlideProps) {
  return (
    <div className="deck-root dark" style={{ background: "var(--svo-dunkelblau)" }}>
      <div className="deck-bg" aria-hidden="true" />

      <header className="deck-head">
        <div className="deck-eyebrow rise rise-1">Digitalisierung &amp; Automatisierung</div>
        <h1 className="deck-title rise rise-2">
          Was heute schon <br />
          <span className="accent">automatisch läuft</span>
        </h1>
        <p className="deck-sub rise rise-3">
          Kein Zukunftsversprechen — das ist bei SVO seit Monaten im Betrieb.
        </p>
      </header>

      <div className="deck-cols2" style={{ gridTemplateRows: "1fr 1fr", gap: 20 }}>
        {TILES.map((t, i) => (
          <div key={t.title} className={`col-card rise rise-${(i % 3) + 4}`}>
            <div className="col-eyebrow">0{i + 1}</div>
            <h4>{t.title}</h4>
            <p>{t.text}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
